export default __webpack_public_path__ + "static/media/right-arrow.9d2c50aa.svg";